export const FormField = ({ id, label, value, onChange, placeholder, as = "input", options = [], testId }) => {
  const fieldClassName =
    "w-full rounded-2xl border border-transparent bg-[#F5F3EC] px-4 py-3 text-sm text-[#2C2F2E] outline-none transition-colors duration-200 placeholder:text-[#5C6360]/55 focus:border-[#4A6753]/40 focus:bg-white focus:ring-4 focus:ring-[#4A6753]/10";
  const handleChange = (event) => onChange(event.target.value);

  return (
    <label className="block" htmlFor={id} data-testid={`${testId}-label-wrapper`}>
      <span className="mb-2 block text-sm font-bold text-[#2C2F2E]" data-testid={`${testId}-label`}>{label}</span>
      {as === "textarea" ? (
        <textarea id={id} value={value} onChange={handleChange} className={fieldClassName} placeholder={placeholder} rows={5} data-testid={testId} />
      ) : as === "select" ? (
        <select id={id} value={value} onChange={handleChange} className={fieldClassName} data-testid={testId}>
          <option value="" data-testid={`${testId}-option-empty`}>
            Valitse...
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value} data-testid={`${testId}-option-${option.value}`}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input id={id} value={value} onChange={handleChange} className={fieldClassName} placeholder={placeholder} data-testid={testId} />
      )}
    </label>
  );
};